// @flow

import Collapse from 'react-collapse';
import cx from 'classnames';
import React, { PureComponent } from 'react';

type Props = {
  title: React$Element<any> | null,
  subtitle: React$Element<any> | null,
  illustration: string | null,
  children: React$Element<any>,
  springConfig: Object,
  isOpen: boolean,
  clickHandler: Function,
  onMeasure: Function,
  last: boolean,
  style: Object | null,
};

const ENTER_KEY = 'Enter';

class Panel extends PureComponent<Props> {
  static defaultProps = {
    title: null,
    subtitle: null,
    illustration: null,
    springConfig: { stiffness: 250, damping: 30 },
    isOpen: false,
    clickHandler: () => {},
    onMeasure: () => {},
    last: false,
    style: null,
  };

  element: Object;

  render() {
    const {
      children,
      title,
      subtitle,
      illustration,
      springConfig,
      isOpen,
      clickHandler,
      onMeasure,
      last,
      style,
    } = this.props;

    return (
      <div
        className={cx('panel', { 'panel--last': last, 'has-image': !!illustration })}
        ref={(ref) => {
          this.element = ref;
        }}
        style={style}>
        <div
          className={cx('bar flex-row', {
            'icon-right-open-mini': !isOpen,
            'icon-down-open-mini': isOpen,
          })}
          tabIndex={0}
          role="link"
          onKeyPress={event => event.key === ENTER_KEY && clickHandler(event, this)}
          onClick={event => clickHandler(event, this)}>
          {illustration && (
            <div className="img-holder">
              <img src={illustration} alt="" />
            </div>
          )}
          <div>
            <div className="title">{title}</div>
            {subtitle && <div className="subtitle">{subtitle}</div>}
          </div>
        </div>
        <Collapse
          isOpened={isOpen}
          springConfig={springConfig}
          onMeasure={({ rectangle, panel }) => onMeasure({ rectangle, panel }, this)}>
          {children}
        </Collapse>
      </div>
    );
  }
}

export default Panel;
